<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">休闲娱乐</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goPublishWorks">
        <div class="module_left">发布作品</div>
        <div class="module_right_icon1 PublishWorks1">
          <div class="module_right_icon2 PublishWorks2">
            <div class="module_right_icon3 PublishWorks3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goFollowWorks">
        <div class="module_left">关注作品</div>
        <div class="module_right_icon1 FollowWorks1">
          <div class="module_right_icon2 FollowWorks2">
            <div class="module_right_icon3 FollowWorks3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goLiveBroadcast">
        <div class="module_left">开直播</div>
        <div class="module_right_icon1 LiveBroadcast1">
          <div class="module_right_icon2 LiveBroadcast2">
            <div class="module_right_icon3 LiveBroadcast3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goSong">
        <div class="module_left">手机K歌</div>

        <div class="module_right_icon1 Song1">
          <div class="module_right_icon2 Song2">
            <div class="module_right_icon3 Song3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goHear">
        <div class="module_left">听书听电台</div>

        <div class="module_right_icon1 Hear1">
          <div class="module_right_icon2 Hear2">
            <div class="module_right_icon3 Hear3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goSee">
        <div class="module_left">手机看剧</div>

        <div class="module_right_icon1 See1">
          <div class="module_right_icon2 See2">
            <div class="module_right_icon3 See3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goFilm">
        <div class="module_left">手机买电影票</div>

        <div class="module_right_icon1 Film1">
          <div class="module_right_icon2 Film2">
            <div class="module_right_icon3 Film3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {}
  },
  created () {},

  mounted () {},
  beforeDestroy () {},

  methods: {
    async goBack () {
      this.$router.replace({
        path: '/classification'
      })
    },
    async goPublishWorks () {
      this.$router.push({
        path: "/entertainment/publishWorks/index",
      });
    },
    async goSee () {
      this.$router.push({
        path: '/entertainment/see/index'
      })
    },
    async goSong () {
      this.$router.push({
        path: '/entertainment/song/index'
      })
    },
    async goHear () {
      this.$router.push({
        path: "/entertainment/hear/index",
      });
    },
    async goFollowWorks () {
      this.$router.push({
        path: '/entertainment/followWorks/index'
      })
    },

    async goLiveBroadcast () {
      this.$router.push({
        path: '/entertainment/liveBroadcast/index'
      })
    },
    async goFilm () {
      this.$router.push({
        path: "/entertainment/film/index",
      });
    }
  }
}
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  /* 黄色 */
  background: linear-gradient(
    180deg,
    rgb(255, 143, 51),
    rgb(255, 188, 92) 31.298%,
    rgb(255, 241, 241) 100%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 30px;
    top: 40px;
    z-index: 0;
    width: 369px;
    height: 260px;
    background: url(@/assets/entertainment/entertainmentIndex/entertainmentIndex_subscript.png)
      no-repeat center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 30px;

  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 325px;
    padding: 27px 0;
    height: 95px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 30px;
    margin-right: 30px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }

    .PublishWorks1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .PublishWorks2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .PublishWorks3 {
      background: url("@/assets/entertainment/entertainmentIndex/publishWorks.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .FollowWorks1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .FollowWorks2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .FollowWorks3 {
      background: url("@/assets/entertainment/entertainmentIndex/followWorks.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .LiveBroadcast1 {
      background: url("@/assets/colorBg/pink1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .LiveBroadcast2 {
      background: url("@/assets/colorBg/pink2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .LiveBroadcast3 {
      background: url("@/assets/entertainment/entertainmentIndex/liveBroadcast.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Song1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Song2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Song3 {
      background: url("@/assets/entertainment/entertainmentIndex/song.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Hear1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Hear2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Hear3 {
      background: url("@/assets/entertainment/entertainmentIndex/hear.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .See1 {
      background: url("@/assets/colorBg/purple1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .See2 {
      background: url("@/assets/colorBg/purple2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .See3 {
      background: url("@/assets/entertainment/entertainmentIndex/see.png")
        no-repeat center;
      background-size: 100% 100%;
    }
    .Film1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Film2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Film3 {
      background: url("@/assets/entertainment/entertainmentIndex/film.png")
        no-repeat center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
